import { combineReducers } from 'redux';
import { baseApi } from '../../api/base-api';
import conversationReducer from './features/conversationSlice';
import conversationsReducer from './features/conversationsSlice';
import integrationReducer from './features/integrationsSlice';
import modelReducer from './features/modelSlice';
import modelsReducer from './features/modelsSlice';
import queryFiltersReducer from './query-filters-reducer';
import organizationReducer from './features/organizationSlice';
import organizationsReducer from './features/organizationsSlice';
import datastreamsReducer from './features/datastreamsSlice';
import datastreamReducer from './features/datastreamSlice';
import apiUserReducer from './features/meSlice';
import organizationUsersReducer from './features/organizationUsersSlice';
import apiKeyReducer from './features/apiKeySlice';
import insightsReducer from './features/insightsSlice';
import socketReducer from './agent-socket-reducer';
import toastReducer from './toast-reducer';
import subscriptionReducer from './features/subscriptionSlice';
import assistantReducer from './features/assistantSlice';
import { IDENTITY_CHANGED } from '../../utils/identity-scope';

const reducers = combineReducers({
  identity: (state = { scope: '', generation: 0 }, action: any) => (action.type === IDENTITY_CHANGED ? { scope: action.payload.scope, generation: action.payload.generation } : state),
  me: apiUserReducer,
  users: organizationUsersReducer,
  integrations: integrationReducer,
  subscription: subscriptionReducer,
  query_filters: queryFiltersReducer,
  conversation: conversationReducer,
  conversations: conversationsReducer,
  insights: insightsReducer,
  model: modelReducer,
  models: modelsReducer,
  toast: toastReducer,
  organization: organizationReducer,
  organizations: organizationsReducer,
  datastreams: datastreamsReducer,
  datastream: datastreamReducer,
  api_keys: apiKeyReducer,
  agent_socket: socketReducer,
  assistant: assistantReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

const rootReducer: typeof reducers = (state, action) => {
  if (action.type === IDENTITY_CHANGED) {
    const initial = reducers(undefined, { type: '@@identity/reset' });
    state = { ...initial, me: (action as any).payload.clearUser ? initial.me : (state?.me ?? initial.me), [baseApi.reducerPath]: state?.[baseApi.reducerPath] ?? initial[baseApi.reducerPath] };
  }
  return reducers(state, action);
};

export default rootReducer;
